import Vue from "vue";

const state = {
    surecler : []
}

const getters = {
    getSurecler(state){
        state.surecler.sort((a,b)=>{
            var x = a.firmaAdi.toLowerCase();
            var y = b.firmaAdi.toLowerCase();
            if (x < y) {return -1;}
            if (x > y) {return 1;}
            return 0;
        });
        return state.surecler;
    },

}

const mutations = {
     updateSurecList(state, surec){
         state.surecler.push(surec);
     },
     deleteSurec(state, index){
        typeof(index)
         state.surecler.splice(index, 1)
     }
}

const actions = {
   initApp({ commit }){
       state.surecler = [];
        Vue.http.get("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/surecler.json")
        .then(response =>{
            let data = response.body;
            for(let key in data){
                data[key].key = key;
                commit("updateSurecList", data[key]);
                console.log(response.data)
            }
        })
   },
   saveSurec({ commit, state,dispatch }, payload){
        Vue.http.post("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/surecler.json", payload)
        .then((response) => {
            payload.key = response.body.name;
            commit("updateSurecList", payload);
            console.log(state.surecler);
            let log= {name: payload.firmaAdi,islem:" SÜREÇ EKLENDİ"}
             dispatch("saveLog", log)
        })
   },
   deleteSurec({commit,dispatch}, payload){
        Vue.http.delete("https://karpiem-a40f7-default-rtdb.europe-west1.firebasedatabase.app/surecler/"+payload[0]+".json")
        .then(response => {
            console.log(response);
            let index = payload[1]
             let log= {name: state.surecler[index].firmaAdi,islem:" SÜRECİ SİLİNDİ"}
             dispatch("saveLog", log)
            commit("deleteSurec",payload[1])
            
        })
   },

}

export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/process.js